<template>
  <div class="d-flex flex-column gap16">
    <div>
      <label class="fsp14 neue-roman text-black lh20 mb8 d-block">
        {{ $t('components.service.modal.p2p.OffersFilters.1') }}
      </label>
      <InputSimple
        id='advertisement'
        :dataValue='this.localFields.advertisement' 
        @updateParentState="this.updateState" 
        :placeholder="$t('components.service.modal.p2p.OffersFilters.3')"
        class="w-100"
        :icon="'hashtag'"
      />
    </div>
    <div>
      <label class="fsp14 neue-roman text-black lh20 mb8 d-block">
        {{ $t('components.service.modal.p2p.OffersFilters.2') }}
      </label>
      <InputSimple
        id='maker'
        :dataValue='this.localFields.maker' 
        @updateParentState="this.updateState" 
        :placeholder="$t('components.service.modal.p2p.OffersFilters.4')"
        class="w-100"
        :icon="'user'"
        :iconColor="{ 0: '#808080', 1: '#808080' }"
      />
    </div>
    <div class="divider" />
    <div class="d-flex justify-content-between align-items-center w-100">
      <label class="fsp14 neue-roman text-black lh20 mb8 d-block">
        {{ $t('components.service.modal.p2p.OffersFilters.5') }}
      </label>
      <SwitchSimple
        id='switch_maker'
        :dataValue='this.localFields.switch_maker'
        @updateParentState="this.updateState"
        class='pl-4 pt-0' 
      />
    </div>
  </div>
</template>

<script>
import InputSimple from '@/components/service/InputSimple'
import SwitchSimple from '@/components/service/SwitchSimple'

export default {
  name: 'OffersFilters',
  components: {
    InputSimple,
    SwitchSimple
  },
  props: {
    initialFilters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localFields: {
        advertisement: '',
        maker: '',
        switch_maker: false
      }
    }
  },
  created() {
    // Инициализируем локальные поля из props, сохраняя значения по умолчанию
    this.localFields = { ...this.localFields, ...this.initialFilters };
    
    // Если maker равен '0' (значение по умолчанию), показываем пустое поле
    if (this.localFields.maker === '0') {
      this.localFields.maker = '';
    }
  },
  watch: {
    initialFilters: {
      handler(newFields) {
        this.localFields = { ...this.localFields, ...newFields };
        
        // Если maker равен '0' (значение по умолчанию), показываем пустое поле
        if (this.localFields.maker === '0') {
          this.localFields.maker = '';
        }
      },
      deep: true
    }
  },
  methods: {
    updateState(state) {
      // Обновляем только локальные поля
      this.localFields[state.id] = state.value;
    },
    clearFilters() {
      this.localFields = {
        advertisement: '',
        maker: '',
        switch_maker: false
      };
    },
    applyFilters() {
      // Эмитим изменения при применении
      this.$emit('updateParentState', { id: 'advertisement', value: this.localFields.advertisement });
      this.$emit('updateParentState', { id: 'maker', value: this.localFields.maker });
      this.$emit('updateParentState', { id: 'switch_maker', value: this.localFields.switch_maker });
    }
  }
}
</script>

<style lang="scss" scoped>
.divider {
  width: 100%;
  height: 1px;
  background-color: $primary-grey;
  opacity: 0.1;
}
</style>
